import { useMemo } from "react";
import intl from "react-intl-universal";
import { Link } from "react-router-dom";
import { TbChevronRight } from "react-icons/tb";
import { StablesGeneralHistoryGrid } from "../../../Stables/components/StablesGeneralHistoryGrid";
import { BAAS_STABLES_TRANSACTIONS_PATH } from "../../constants";
import { mapBaasOperationsToStablesHistory } from "../baasStablesHistoryMapper";

const buildViewAllPath = (walletId) => {
  if (!walletId) return BAAS_STABLES_TRANSACTIONS_PATH;
  return `${BAAS_STABLES_TRANSACTIONS_PATH}?walletId=${encodeURIComponent(walletId)}`;
};

export const BaasStablesRecentActivity = ({
  operations = [],
  maxRows = 8,
  walletId = null,
}) => {
  const historyItems = useMemo(
    () => mapBaasOperationsToStablesHistory(operations).slice(0, maxRows),
    [operations, maxRows],
  );

  if (!historyItems.length) {
    return (
      <section className="min-w-0 w-full">
        <p className="dashboard-section-label mb-2">
          {intl.get("baas.stablesWallet.recentActivity.section")}
        </p>
        <div className="rounded-xl border border-gray-200 bg-white px-3 py-2.5 dark:border-brand-dark-border dark:bg-brand-dark-surface">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {intl.get("baas.stablesWallet.recentActivity.empty")}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="min-w-0 w-full">
      <div className="mb-2 flex items-center justify-between gap-3">
        <p className="dashboard-section-label">
          {intl.get("baas.stablesWallet.recentActivity.section")}
        </p>
        <Link
          to={buildViewAllPath(walletId)}
          className="link-no-zoom inline-flex items-center gap-1 text-xs font-semibold text-[#e7a73f] transition hover:text-brand-dark dark:hover:text-gray-200"
        >
          {intl.get("baas.stablesWallet.recentActivity.viewAll")}
          <TbChevronRight className="h-3.5 w-3.5" />
        </Link>
      </div>

      <div className="app-card overflow-hidden">
        <StablesGeneralHistoryGrid items={historyItems} showDetail={false} />
      </div>
    </section>
  );
};
